module.exports = __webpack_public_path__ + "static/media/telerama.2c5e2ace.png";